export enum AuthForm {
  SignUp = 'signup',
  Login = 'login'
}
